import {NavLink} from "react-router-dom";
import React from "react";

const ProviderMainMenu = () => {
  return <>
    {/*<li className="nav-item">*/}
    {/*  <NavLink to="/dashboard" className="nav-link close-nav">Dashboard</NavLink>*/}
    {/*</li>*/}
    {/*<li className="nav-item">*/}
    {/*  <NavLink to='/reports' className="nav-link close-nav">Rapoarte</NavLink>*/}
    {/*</li>*/}
    {/*<li className="nav-item">*/}
    {/*  <NavLink className="nav-link close-nav" to="/dashboard">*/}
    {/*    Dashboard*/}
    {/*  </NavLink>*/}
    {/*</li>*/}
    <li className="nav-item">
      <NavLink className="nav-link close-nav" to="/clients">
        Clienti
      </NavLink>
    </li>
    <li className="nav-item">
      <NavLink className="nav-link close-nav" to="/menus">
        Meniuri
      </NavLink>
    </li>
    <li className="nav-item">
      <NavLink className="nav-link close-nav" to="/plates">
        Retete
      </NavLink>
    </li>
    <li className="nav-item">
      <NavLink className="nav-link close-nav" to="/ingredients">
        Ingrediente
      </NavLink>
    </li>
    <li className="nav-item">
      <NavLink className="nav-link close-nav" to="/categories">
        Mesele zilei
      </NavLink>
    </li>
  </>
}
export default ProviderMainMenu